module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<img src=\"/images/logos/logo-white.svg\" />\n<div class=\"info\">\n<div class=\"version\">Tarantula v<%= (storage.app || {}).version || '0.0.0' %></div>\n<div class=\"lastUpdate\"><%= storage.__('logo.lastUpdate', { ts: utils.moment((storage.app || {}).upStartTimestamp).format('DD.MM.YYYY') }) %></div>\n</div>\n<%\nif(storage.app.webService.name){\n%><div class=\"projectName\"><%= storage.app.webService.name %></div><%\n}\n%>\n</div>"
  , __filename = "components/templates/nav/logo.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n<img src=\"/images/logos/logo-white.svg\" />\n<div class=\"info\">\n<div class=\"version\">Tarantula v")
    ; __line = 4
    ; __append(escapeFn( (storage.app || {}).version || '0.0.0' ))
    ; __append("</div>\n<div class=\"lastUpdate\">")
    ; __line = 5
    ; __append(escapeFn( storage.__('logo.lastUpdate', { ts: utils.moment((storage.app || {}).upStartTimestamp).format('DD.MM.YYYY') }) ))
    ; __append("</div>\n</div>\n")
    ; __line = 7
    ; 
if(storage.app.webService.name){

    ; __line = 9
    ; __append("<div class=\"projectName\">")
    ; __append(escapeFn( storage.app.webService.name ))
    ; __append("</div>")
    ; 
}

    ; __line = 11
    ; __append("\n</div>")
    ; __line = 12
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/nav/logo.ejs

}